import {useEffect, useState} from "react";

import { bindActionCreators } from "redux";
import { ReactElement } from "react";

import { Box, Spinner } from "@twilio-paste/core";

import Login from "./login/login";
import AppContainer from "./AppContainer";
import { actionCreators, AppState } from "../store";
import { getToken } from "../api";

import useSelector from "../hooks/useSelector";
import useDispatch from "../hooks/useDispatch";



function App({setNewMessages, resetKey}): ReactElement {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { login } = bindActionCreators(actionCreators, dispatch);
  const token = useSelector((state: AppState) => state.token);

  const username = localStorage.getItem("username") ?? "kevin@sussd.ie";
  const password = localStorage.getItem("password") ?? "none required";
  const unreadMessages = useSelector((state: AppState) => state.unreadMessages);

  const unread = Object.values(unreadMessages).reduce((acc, cur)=>{
    return acc + cur;
  },0)
  useEffect(() => {
      setNewMessages(unread);
  }, [unread]);

  useEffect(() => {
      getToken()
        .then((token) => {

          localStorage.setItem("username", "kevin@sussd.ie");
          localStorage.setItem("password", "none required");
          login(token);
        })
        .catch(() => {
          localStorage.setItem("username", "");
          localStorage.setItem("password", "");
        })
        .finally(() => {
          setLoading(false);
        });
  }, []);

  const setToken = (token: string) => {
    login(token);
    setLoading(false);
  };
  if ((!token && !loading) || !username || !password) {
    return <Login setToken={setToken} />;
  }

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        position="absolute"
        height="100%"
        width="100%"
      >
        <Spinner size="sizeIcon110" decorative={false} title="Loading" />
      </Box>
    );
  }

  return <AppContainer  resetKey={resetKey} />;
}

export default App;
